import React from "react"
import RoundingMonitorCardWithData from "../../components/RoundingMonitor/RoundingMonitorCardWithData"

const RoundingMonitor = () => <RoundingMonitorCardWithData />

export { RoundingMonitor }
